/**
 * A media query as React state. For the one layout decision Tailwind classes cannot make: which
 * *component tree* to render. `md:hidden`/`md:block` can hide a copy, but rendering the search
 * panel twice put two inputs with one id in the document — a screen reader announced both and a
 * test harness found the hidden one. When the tree itself differs by width, ask the width.
 *
 * `useSyncExternalStore` so the first render on the client is already correct; no flash of the
 * wrong tree.
 */

import { useSyncExternalStore } from 'react';

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const media = window.matchMedia(query);
      media.addEventListener('change', onChange);
      return () => {
        media.removeEventListener('change', onChange);
      };
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** The two-panel surface, per `breakpoint.md` in the token package. */
export const TWO_PANEL = '(min-width: 768px)';
